import {
  SUB_AVAILABLE_MODULE_ALL,
  SUB_AVAILABLE_MODULE_ERROR,
  SUB_AVAILABLE_MODULE_LOADING,
  SUB_AVAILABLE_MODULE_PUT,
} from '../../actions/types';

const initialState = {
  information: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case SUB_AVAILABLE_MODULE_LOADING:
      return { isLoading: true, isCompleted: true };
    case SUB_AVAILABLE_MODULE_ERROR:
      return { isLoading: false, isCompleted: false, ...action.payload };
    case SUB_AVAILABLE_MODULE_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case SUB_AVAILABLE_MODULE_PUT:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
